export default "__VITE_ASSET__aadb3274__"